// extracted by mini-css-extract-plugin
export default {"teacherNotes":"teacherNotes__iQET6"};